export async function copyTextToClipboard(text: string): Promise<void> {
  const normalized = text.trim();

  if (!normalized) {
    throw new Error('Texto vazio para copiar.');
  }

  try {
    await navigator.clipboard.writeText(normalized);
    return;
  } catch {
    /* fallback below */
  }

  const textarea = document.createElement('textarea');
  textarea.value = normalized;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    const copied = document.execCommand('copy');
    if (!copied) {
      throw new Error('Não foi possível copiar o texto.');
    }
  } finally {
    document.body.removeChild(textarea);
  }
}
